import React, { useState, useRef, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import './MultipleSelect.scss';

const MultipleSelect = ({ 
  options = [], 
  selectedValues = [], 
  onSelectionChange = () => {}, 
  placeholder = "Selecione...",
  disabled = false,
  className = "",
  maxHeight = "200px"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
    option.value.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOptionClick = (option) => {
    const isSelected = selectedValues.some(selected => selected.value === option.value);
    
    if (isSelected) {
      const newSelection = selectedValues.filter(selected => selected.value !== option.value);
      onSelectionChange(newSelection);
    } else {
      const newSelection = [...selectedValues, option];
      onSelectionChange(newSelection);
    }
  };

  const handleRemoveOption = (optionToRemove, event) => {
    event.stopPropagation();
    const newSelection = selectedValues.filter(selected => selected.value !== optionToRemove.value);
    onSelectionChange(newSelection);
  };

  const handleInputClick = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setIsOpen(false);
    }
  };

  return (
    <div className={`multiple-select ${className}`} ref={dropdownRef}>
      <div 
        className={`multiple-select-control ${disabled ? 'disabled' : ''} ${isOpen ? 'open' : ''}`}
        onClick={handleInputClick}
      >
        <div className="multiple-select-value">
          {selectedValues.length === 0 ? (
            <span className="placeholder">{placeholder}</span>
          ) : (
            <div className="selected-items">
              {selectedValues.map((option, index) => (
                <span key={index} className="selected-item">
                  <span className="selected-item-label">{option.label}</span>
                  {!disabled && (
                    <i 
                      className="bi bi-x selected-item-remove"
                      onClick={(e) => handleRemoveOption(option, e)}
                    ></i>
                  )}
                </span>
              ))}
            </div>
          )}
        </div>
        <div className="multiple-select-arrow">
          <i className={`bi ${isOpen ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
        </div>
      </div>

      {isOpen && (
        <div className="multiple-select-menu" style={{ maxHeight }}>
          <div className="multiple-select-search">
            <Form.Control
              ref={inputRef}
              type="text"
              placeholder="Buscar..."
              value={searchTerm}
              onChange={handleSearchChange}
              onKeyDown={handleKeyDown}
              autoFocus
            />
          </div>
          <div className="multiple-select-options">
            {filteredOptions.length === 0 ? (
              <div className="no-options">Nenhuma opção encontrada</div>
            ) : (
              filteredOptions.map((option, index) => {
                const isSelected = selectedValues.some(selected => selected.value === option.value);
                const isHidden = option.hidden || false;
                
                if (isHidden) return null;
                
                return (
                  <div
                    key={index}
                    className={`multiple-select-option ${isSelected ? 'selected' : ''} ${option.disabled ? 'disabled' : ''}`}
                    onClick={() => !option.disabled && handleOptionClick(option)}
                  >
                    <div className="option-checkbox">
                      <i className={`bi ${isSelected ? 'bi-check-square' : 'bi-square'}`}></i>
                    </div>
                    <div className="option-label">{option.label}</div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultipleSelect;
